// extracted by mini-css-extract-plugin
export var connectionButton = "_bo-1";
export var rightPanel = "_bo-3";
export var stepDescription = "_bo-2";
export var stepIcon = "_bo-0";